import classNames from "classnames";
import "./index.scss";
import WindowMac from "./WindowMac";
import IOSAndHD from "./IOSAndHD";
import React from "react";
import TVComponent from "./TVComponent";
import MoreProductsComponent from "./MoreProductsComponent";
import { showDownloadTabpage } from "@/report";
import { useAnimationTime } from "@/hooks";

enum ENavType {
  PC = "PC",
  MOBILE = "MOBILE",
  TV = "TV",
  MORE = "MORE",
}

interface IClientAppProps {
  isBigScreen: boolean;
}
const ClientApp: React.FC<IClientAppProps> = ({ isBigScreen }) => {
  const [curNav, setCurNav] = React.useState<ENavType>(ENavType.PC);
  const { isAnimationFirst, addAnimationTime } = useAnimationTime();

  const NavList = [
    {
      title: "电脑端",
      desc: "Windows、Mac",
      id: ENavType.PC,
      navTag: ["pc", "mac"],
      component: <WindowMac isBigScreen={isBigScreen} />,
    },
    {
      title: "移动端",
      desc: "iOS 、Android、HD",
      id: ENavType.MOBILE,
      navTag: ["android", "iphone", "ipad", "pad"],
      component: <IOSAndHD isBigScreen={isBigScreen} />,
    },
    {
      title: "智能终端",
      desc: "TV端",
      id: ENavType.TV,
      navTag: ["tv"],
      component: <TVComponent isBigScreen={isBigScreen} />,
    },
    {
      title: "更多产品",
      desc: "极速版、三角洲工具、加速器",
      id: ENavType.MORE,
      navTag: ["pc_express"],
      component: <MoreProductsComponent isBigScreen={isBigScreen} />,
    },
  ];
  const curNavCompnent = React.useMemo(() => {
    const found = NavList.find(item => item.id === curNav);
    return found ? found.component : null;
  }, [curNav, NavList]);
  React.useEffect(() => {
    const navTag = window.location.hash.replace("#", "");
    const navItem = NavList.find(item => item.navTag.includes(navTag));
    if (navItem) {
      setCurNav(navItem.id);
    }
  }, []);
  React.useEffect(() => {
    const reportTab = {
      [ENavType.PC]: "0",
      [ENavType.MOBILE]: "1",
      [ENavType.TV]: "2",
      [ENavType.MORE]: "3",
    };
    showDownloadTabpage({
      tab: reportTab[curNav],
    });
  }, [curNav]);

  return (
    <>
      <div
        className={
          "hide-scroll-bar relative flex-1 overflow-y-auto pb-[180px]"
          // isBigScreen
          //   ? "absolute bottom-0 left-0 right-0 top-0"
          //   : "relative flex-1 overflow-y-auto pb-[180px]"
        }
      >
        {curNavCompnent}
        <div
          id="nav-list-container"
          className={classNames(
            "nav-list-animation fixed bottom-[60px] left-[50%] flex h-[90px] translate-x-[-50%] items-center justify-center rounded-[8px] px-[32px] py-[20px]",
            !isAnimationFirst && "ani-delay-300",
          )}
          style={{
            background: "rgba(0, 0, 0, 0.4)",
            backdropFilter: "blur(12.5px)",
            width: "max-content",
          }}
        >
          {NavList.map((item, index) => {
            const isActive = item.id === curNav;
            return (
              <div
                key={index}
                className="mr-[80px] cursor-pointer last-of-type:mr-0"
                onClick={() => {
                  setCurNav(item.id);
                  window.location.hash = `#${item.navTag[0]}`;
                  addAnimationTime();
                }}
              >
                <div
                  className={classNames(
                    isActive
                      ? "text-[20px] leading-[28px] text-[#FFFFFF]"
                      : "text-[16px] leading-[21px] text-[#FFFFFFBF]",
                  )}
                >
                  {item.title}
                </div>
                <div
                  className={classNames(
                    "text-[13px] font-[400] leading-[21px]",
                    isActive ? "text-[#FFFFFF]" : "text-[#FFFFFF57]",
                  )}
                >
                  {item.desc}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ClientApp;
